module.exports = __webpack_public_path__ + "static/media/reviews.28133a97.svg";